import {
  ODataHeader,
  ODataString,
  ODataDate,
  ODataBoolean,
  ODataEnum,
  ODataDecimal
} from "pbas-vue-components";
import { translate } from '../trans'
import { i18n } from '@/plugins/i18n';
import store from '@/store'
// import { slice } from "core-js/fn/array";

const TaxesHeaders = [
  new ODataHeader({
    type: new ODataString("IdentityId"),
    sortable: true,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false
  }),
  new ODataHeader({
    title: "globals.type",
    type: new ODataEnum("TaxType", {
      getString: (item) => {
        return i18n.t("enums." + item.TaxType);
      },
      dropdownItems: store.getters['plansMembers/options'].Enums.TaxType
    }),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "headers.taxes.rate",
    type: new ODataDecimal("TaxRate", {
      getString: (item, type) => {
        const value = item.TaxRate;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        let v = (parseFloat(item.TaxRate) * 100).toFixed(4);

        if (v.slice(-1) === "0") {
          v = v.slice(0, -1);
          if (v.slice(-1) === "0") {
            v = v.slice(0, -1);
          }
        }
        return v + "%";
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.taxes.is_federal",
    type: new ODataBoolean("IsFederal"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    type: new ODataString("Identity/Province/Id"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("Identity/Province/Code"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("Identity/Province/Name"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("Identity/Province/Translations[]/LanguageCode"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "globals.province",
    type: new ODataString("Identity/Province/Translations[]/DisplayValue", {
      getString: (item) => {
        const lang = store.getters['common/language']
        return translate(item.Identity.Province, lang.language);
      }
    }),
    sortable: true,
    visible: true,
    searchable: true,
    orderByKey: "Identity/Province/Name"
  }),
  new ODataHeader({
    title: "components.inmemorydependants.effective_date",
    type: new ODataDate("EffectiveDate"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("Identity/HasHistory"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
];
export default TaxesHeaders;
